export default class topDeveloper {
    constructor() {
        this.$continer = $("#p-developer__list");

        /* status */
        this.LIMIT = this.$continer.find("ul").innerWidth();


    }
    init(){

        // Draggable.create("#p-developer__list", {type:"scrollLeft", edgeResistance:0.5, throwProps:true});

    }
    set(){

    }
    motion(){

    }
}